import { useSiteStore } from '@/stores/site';
import LayerType from '@/types/LayerType';
import i18n from '@/utils/i18n';

const { t } = i18n.global;

export const layerTypes: LayerType[] = [
    {
        id: 'image',
        label: 'Image',
        icon: 'ri:image-line',
        // @ts-ignore
        form: defineAsyncComponent(() => import('@/components/Layer/Form/LayerFormImage.vue')),
        // @ts-ignore
        view: defineAsyncComponent(() => import('@/components/Layer/View/LayerViewImage.vue')),
        // @ts-ignore
        rowView: defineAsyncComponent(() => import('@/components/Layer/RowView/LayerRowViewImage.vue'))
    },
    {
        id: 'text',
        featureName: 'Texts',
        label: 'Text',
        icon: 'ri:italic',
        // @ts-ignore
        form: defineAsyncComponent(() => import('@/components/Layer/Form/LayerFormText.vue'))
    },
    {
        id: 'group',
        featureName: 'Groups',
        label: '',
        icon: '',
        // @ts-ignore
        form: defineAsyncComponent(() => import('@/components/Layer/Form/LayerFormColors.vue')),
        // @ts-ignore
        rowView: defineAsyncComponent(() => import('@/components/Layer/LayerRowColors.vue'))
    },
    { id: 'shape', label: 'Shape', icon: 'ri:shapes-fill' },
    { id: 'clipart', label: 'Clipart', icon: 'ri:puzzle-line' },
    {
        id: 'backpattern',
        featureName: 'Patterns',
        label: 'Pattern',
        icon: 'ri:shadow-fill',
        route: '//products/[productId]/customize.pattern',
        // @ts-ignore
        view: defineAsyncComponent(() => import('@/components/Layer/Form/LayerFormColors.vue'))
    },
    {
        id: 'graduation',
        featureName: 'Measures',
        label: 'Graduation',
        icon: 'ri:list-ordered',
        route: '//products/[productId]/customize.graduation'
    }
];

export function getAvailableLayerTypes(): LayerType[] {
    const siteStore = useSiteStore();
    return layerTypes.filter(
        (layerType) =>
            (!layerType.featureName || siteStore.isFeatureEnabled(layerType.featureName)) &&
            !['shape', 'clipart'].includes(layerType.id)
    );
}
